import styled from 'styled-components';

export default styled.div`
  .account-activity-detail-title {
    color: #212121;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 32px;
  }
  .account-activity-detail-row {
    display: flex;
    flex-wrap: wrap;
    gap: 32px 56px;
  }
  .account-activity-detail-field {
    display: flex;
    flex-direction: column;
  }
  .account-activity-detail-field-label {
    font-size: 12px;
    color: #212100;
    margin-bottom: 8px;
  }
  .account-activity-detail-coupon-toolbar {
    display: flex;
    align-items: center;
    gap: 16px;
    margin: 8px 0 24px 0;
  }
  .account-activity-detail-coupon-table {
    border-radius: 4px;
    overflow: hidden;
    & > div {
      padding: 0;
    }
  }
  .account-activity-detail-footer {
    margin-top: 32px;
    padding: 24px;
    background: #fff;
    border-radius: 12px;
    display: flex;
    gap: 16px;
  }
  .account-activity-detail-actions {
    display: flex;
    gap: 0 16px;
    margin-top: 14px;
    padding: 32px;
    border-radius: 12px;
    background: #fff;
  }
  .coupon-button-wrap {
    padding-top: 48px;
  }
  .input-error-style {
    color: #f44336;
    margin: 0;
    font-size: 0.75rem;
    margin-top: 3px;
    text-align: left;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-weight: 400;
    line-height: 1.66;
    letter-spacing: 0.03333em;
  }
`;
